import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { PositionLoader, PositionLoaderData } from './position-loader.interface';

@Injectable({
    providedIn: 'root',
})
export class LoaderService {
    private showLoaderSubject$ = new BehaviorSubject<PositionLoaderData>({
        position: PositionLoader.right,
        flag: false,
    });

    // Tracks a hide() call deferred to the next macrotask (see hide() below). A subsequent
    // show() that arrives before that timer fires (e.g. a switchMap cancelling a stale
    // request while a new one starts synchronously) must cancel it, otherwise the deferred
    // hide would incorrectly hide the loader while the new request is still in flight.
    private pendingHideTimeoutId: ReturnType<typeof setTimeout> | null = null;

    show(position?: PositionLoader): void {
        this.cancelPendingHide();
        const positionLoaderData: PositionLoaderData = {
            position: position ? position : PositionLoader.right,
            flag: true,
        };
        this.showLoaderSubject$.next(positionLoaderData);
    }

    hide(): void {
        this.cancelPendingHide();
        const positionLoaderData: PositionLoaderData = {
            position: PositionLoader.right,
            flag: false,
        };
        this.pendingHideTimeoutId = setTimeout(() => {
            this.pendingHideTimeoutId = null;
            this.showLoaderSubject$.next(positionLoaderData);
        });
    }

    get showLoader$(): BehaviorSubject<PositionLoaderData> {
        return this.showLoaderSubject$;
    }

    private cancelPendingHide(): void {
        if (this.pendingHideTimeoutId !== null) {
            clearTimeout(this.pendingHideTimeoutId);
            this.pendingHideTimeoutId = null;
        }
    }
}
